import { useEffect, useRef, useState } from 'react'

export const usePortalById = (id: string) => {
  const ref = useRef<HTMLElement | null>(null)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    let rootElem = document.getElementById(id)

    if (!rootElem) {
      rootElem = document.createElement('div')
      rootElem.id = id
      document.body.appendChild(rootElem)
    }

    ref.current = rootElem
    setMounted(true)

    // return () => {
    //   if (ref.current && ref.current.childNodes.length === 0) {
    // ref.current.remove()
    //   }
    // }
  }, [id])

  return mounted ? ref.current : null
}
